module.exports = __webpack_public_path__ + "img/30.0028faf0.png";